import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css'
import { ToastContainer } from 'react-toastify'
import ProtectedRoute from './utils/ProtectedRoute'
import Landing from './pages/landing/Landing'
import UserLogin from './pages/auth/UserLogin'
import UserDashboard from './pages/userDashboard/Dashboard'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import CreateAccount from './pages/auth/CreateAccount'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ScrollToTop from './utils/ScrollToTop'
import TAC from './pages/termsAndConditions/TAC'
import Privacy from './pages/privacy/Privacy'

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/terms-and-conditions' element={<TAC />} />
        <Route path='/privacy-policy' element={<Privacy />} />
        {/* <Route path='/' element={<UserLogin />} /> */}
        <Route path='/create-account' element={<CreateAccount />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset' element={<ResetPassword />} />
        <Route path='/login' element={<UserLogin />} />
        <Route element={<ProtectedRoute />}>
          {/* //User Dashboard */}
          <Route path='/developer/:page' element={<UserDashboard />} />
          <Route path='/developer/:page/:id' element={<UserDashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
